<template>
  <div class="tako-app-select-options">
    <el-option
      v-for="app in apps"
      :key="app.id"
      :label="app.appname"
      :value="app.id"
    >
      <div>
        <span style="float: left">{{ app.appname }}</span>
        <span style="float: right; padding-left: 30px; font-size: 16px">
          <i
            :class="['iconfont', 'icon-' + iconEnum[app.platform - 1]]"
            :style="{
              color: iconColorEnum[app.platform - 1],
            }"
          ></i>
        </span>
      </div>
    </el-option>
  </div>
</template>

<script setup>
import { defineProps } from "vue";

const props = defineProps({
  apps: {
    type: Array,
    required: true,
  },
});

const iconColorEnum = [
  "rgba(142, 142, 142, 1)",
  "rgba(109, 193, 101, 1)",
  "rgba(18, 150, 219, 1)",
  "rgba(142, 142, 142, 1)",
  "rgba(0, 0, 0, 1)",
];
const iconEnum = ["apple", "android", "windows", "app-store", "linux"];
</script>
